import { useSearchParams } from 'react-router'

import { getListPreFilters } from '../utils/filter'

// A drill-out keeps the filter state in memory, so the saved one stays.
export function useListPreFilter({ mineFilters, preFilters }) {
  const [searchParams] = useSearchParams()

  const listPreFilters = getListPreFilters({
    mineFilters,
    preFilters,
    searchParams,
  })

  const hasPreFilter = listPreFilters !== null

  function transformInitialFilters(filters) {
    return { ...filters, ...listPreFilters }
  }

  return {
    hasPreFilter,
    preFilterKey: JSON.stringify(listPreFilters),
    transformInitialFilters: hasPreFilter ? transformInitialFilters : undefined,
  }
}
